import React from "react";
import jokerImage from '../assets/joker.png';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const PokerCard = ({card, wrapperClass = '', wrapperStyle = {}, isShowType = false, isShowPickedSymbol = false, isShowMoneySymbol = false}) => {
    if (!card || !card.cardId){
      return <div className={`card pokerCard`} draggable={false} style={{opacity: 0}}>
  </div>
    }

    const changeCardRank = (rank) => {
      return rank === '1' ? 'A' : rank === '11' ? 'J' : rank === '12' ? 'Q' : rank === '13' ? 'K' : rank;
    }
    
    const getCardTypeSymbol = (type) => {
      return type === 'spades' ? '\u2660' : type === 'hearts' ? '\u2665' : type === 'diamonds' ? '\u2666' : type === 'clubs' ? '\u2663' : '';
    }

    return (
      card.type === 'jokers' ? (
        <div key={`${card.cardId}`} className={`poker-card-face joker-card ${card.rank} ${wrapperClass || ''}`} style={wrapperStyle} draggable={false}>
          <div className="joker-text">JOKER</div>
          <div className="joker-image"><img alt="" src={jokerImage} draggable={false}></img></div>
          <div className="joker-text-reverse">JOKER</div>
        </div>) : (
        <div key={`${card.cardId}`} className={`poker-card-face ${card.type} ${wrapperClass || ''}`} style={wrapperStyle} draggable={false}>
          <div className="pokerCard-rank-symbol">
            <span className="pokerCard-rank">{changeCardRank(card.rank)}</span>
            <span className="pokerCard-symbol">
              {getCardTypeSymbol(card.type)}
            </span>
          </div>
          {/* {isShowType && */}
            <span className="pokerCard-type" style={{display: isShowType ? 'block' : 'none'}}>
              {getCardTypeSymbol(card?.type)}
            </span>
          {/* } */}
          {isShowPickedSymbol &&
            <span className="picked-symbol" style={{ position: 'absolute', top: '30%', left: '5%', color: 'black' }}>
              <EnhancedEncryptionIcon sx={{ fontSize: { xs: '0.7rem', md: '0.8rem' } }} />
            </span>
          }
          {isShowMoneySymbol &&
            <span className="picked-symbol" style={{ position: 'absolute', top: '50%', left: '3%', color: 'black' }}>
              <MonetizationOnIcon sx={{ fontSize: { xs: '0.7rem', md: '0.8rem' } }} />
            </span>
          }
          <div className="pokerCard-rank-symbol-reverse">
            <span className="pokerCard-rank">{changeCardRank(card.rank)}</span>
            <span className="pokerCard-symbol">
              {getCardTypeSymbol(card.type)}
            </span>
          </div>
        </div>)
    )
  }

  export default PokerCard;
